
import _ from 'lodash';

export function orderModules(startModuleId, modules) {
    const tmpModules = [];

    if (!startModuleId) {
        return modules;
    }

    if (modules.length) {
        let nextMod = [startModuleId];
        let diff;
        do {
            while (nextMod.length > 0) {
                const nModId = nextMod.pop();
                const nMod = _.find(modules, { id: nModId });

                if (!nMod || _.find(tmpModules, { id: nMod.id })) {
                    continue;
                }

                tmpModules.push(nMod);
                if (nMod.fallback) {
                    nextMod.push(nMod.fallback);
                } else if (nMod.connection && nMod.connection.length) {
                    const goto = _.map(nMod.connection, 'goto');
                    nextMod = nextMod.concat(goto.reverse());
                }
                // Follow trigger edges (scheduled delays, etc.)
                if (nMod.triggers && nMod.triggers.length) {
                    const triggerGotos = nMod.triggers
                        .filter(t => !t.deleted_at && t.goto_module_id)
                        .map(t => t.goto_module_id);
                    nextMod = nextMod.concat(triggerGotos.reverse());
                }
            }

            diff = _.differenceWith(modules, tmpModules, _.isEqual);
            if (diff.length > 0) {
                nextMod.push(diff[0].id);
            }
        } while(diff.length > 0);
    }

    return tmpModules;
}

// insert cardActive for expandable card
export function addCardActive(modules) {
    return modules.map(module => {
        return {
            ...module,
            cardActive: false
        }
    })
}